<script>
    import BaseListener from "@/assets/plugins/mps-common/event/base-listener";
    import {ON_SYSTEM_PERMISSION_GROUP_RECEIVED} from "@/framework/listeners/listeners";

    export default {
        extends: BaseListener,
        name: "OnSystemPermissionGroupReceivedListener",
        created() {
            this.registerListener(ON_SYSTEM_PERMISSION_GROUP_RECEIVED, this.onSystemPermissionGroupReceived);
        },
        beforeDestroy() {
            this.unregisterListener(ON_SYSTEM_PERMISSION_GROUP_RECEIVED, this.onSystemPermissionGroupReceived);
        }
    }
</script>
